const modals = {
  id: null,
  acceptOrderNumber: null,
  amount: null,
  orderMode: null,
  productList: null,
  purchaseOrderNumber: null,
  receiveTime: null,
  remark: null,
  shopName: null,
};
export default modals;
